const t = {
  name: "Innovation",
  dimensions: { width: 26, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 26 40" style="enable-background:new 0 0 26 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M13,0C5.8,0,0,5.8,0,13c0,4.6,2.4,8.6,6,10.9V36h14V23.9c3.6-2.3,6-6.3,6-10.9C26,5.8,20.2,0,13,0z M2,13
			C2,6.9,6.9,2,13,2c6.1,0,11,4.9,11,11c0,4.1-2.2,7.6-5.5,9.5L18,22.8V26h-4v-9.1c1.7-0.4,3-2,3-3.9c0-2.2-1.8-4-4-4
			c-2.2,0-4,1.8-4,4c0,1.9,1.3,3.4,3,3.9V26H8v-3.2l-0.5-0.3C4.2,20.6,2,17.1,2,13z M8,28h10v2H8V28z M18,32v2H8v-2H18z M11,13
			c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2C11.9,15,11,14.1,11,13z"/>
		<path class="st0" d="M9,40v-2h8v2H9z"/>
	</g>
</g>
</svg>
  `
};
export {
  t as Innovation
};
